import { render } from "./generalcomment.vue?vue&type=template&id=4958e63d"
import script from "./generalcomment.vue?vue&type=script&lang=js"
export * from "./generalcomment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__